<template>
  <div>
    <table class="table mb-0 table-striped">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">#</th>
          <th scope="col" class="border-0">Cidade</th>
          <th scope="col" class="border-0">Estado</th>
          <th scope="col" class="text-center border-0">Distribuidores Regionais</th>
          <th scope="col" class="text-center border-0">Distribuidores Estaduais</th>
          <th scope="col" class="text-center border-0">Indicações 30d</th>
          <th scope="col" class="border-0">Opções</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in regions" :key="index">
          <td class="td-1">{{ row.id }}</td>
          <td class="td-2 link">
            <router-link
              :to="{ name: 'admin-region-edit', params: { id: row.id } }"
            >
              {{ row.city }}
            </router-link>
          </td>
          <td class="td-2">{{ row.state }}</td>
          <td class="td-2 text-center">{{ row.regional_resellers_count }}</td>
          <td class="td-2 text-center">{{ row.state_resellers_count }}</td>
          <td class="td-2 text-center">{{ row.leads_count }}</td>
          <td class="td-2">
            <region-buttons :region="row" />
          </td>
        </tr>
        <tr v-if="regions.length === 0">
          <td colspan="7" class="no-content">
            Ainda não tem nenhuma região cadastrada.
          </td>
        </tr>
      </tbody>
    </table>

    <div class="import-modals">
      <confirmation-modal
        :cancel="close"
        :confirm="deleteRow"
        title="Confirme exclusão da Região"
        message="Tem certeza que deseja excluir essa Região?"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import { _DELETE_REGION_ } from './RegionModel';
import RegionButtons from './RegionButtons.vue';

export default {
  name: 'region-table',
  components: {
    RegionButtons,
    ConfirmationModal,
  },
  props: {
    regions: {
      type: Array,
    },
  },
  data() {
    return {
      selectRegion: null,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert', 'deleteRegion']),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      this.deleteRegion(this.selectRegion)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', false);
          this.$router.push('/admin/regiao/lista/1');
          this.activeAlert({
            message: 'Região deletada com sucesso',
            theme: 'success',
          });
        })
        .catch(error =>
          this.activeAlert({ message: error.message, theme: 'danger' })
        )
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_REGION_, region => {
      this.selectRegion = region.id;
    });
  },
  destroyed() {
    Events.$off(_DELETE_REGION_);
  },
};
</script>
